import type { IImage } from "@sablier/v2-types";
import IconArbitrum from "./arbitrum.png";
import IconAvalanche from "./avalanche.png";
import IconBase from "./base.png";
import IconBinanceSmartChain from "./bsc.png";
import IconTestnet from "./ethereum-gray.png";
import IconEthereum from "./ethereum-purple.png";
import IconGnosis from "./gnosis.png";
import IconPolygon from "./matic.png";
import IconOptimism from "./optimism.png";

/**
 * Keep hardcoded values here because imports from @sablier/v2-constants
 * will expose this file to dependencies like lodash, which will
 * break the OG Meta Image generator (see client/pages/api).
 */

const CHAIN_ARBITRUM_ID = 42161;
const CHAIN_AVALANCHE_ID = 43114;
const CHAIN_BASE_ID = 8453;
const CHAIN_BSC_ID = 56;
const CHAIN_ETHEREUM_ID = 1;
const CHAIN_GOERLI_ID = 5;
const CHAIN_GNOSIS_ID = 100;
const CHAIN_OPTIMISM_ID = 10;
const CHAIN_POLYGON_ID = 137;
const CHAIN_SEPOLIA_ID = 11155111;

const chainAssets: Record<number, IImage> = {
  [CHAIN_ARBITRUM_ID]: IconArbitrum,
  [CHAIN_AVALANCHE_ID]: IconAvalanche,
  [CHAIN_BASE_ID]: IconBase,
  [CHAIN_BSC_ID]: IconBinanceSmartChain,
  [CHAIN_ETHEREUM_ID]: IconEthereum,
  [CHAIN_GOERLI_ID]: IconTestnet,
  [CHAIN_GNOSIS_ID]: IconGnosis,
  [CHAIN_OPTIMISM_ID]: IconOptimism,
  [CHAIN_POLYGON_ID]: IconPolygon,
  [CHAIN_SEPOLIA_ID]: IconTestnet,
};

export default chainAssets;
